import { Game } from '../../../interfaces/Games.interface';
import dayjs from 'dayjs';

type UseGamesFromSelectedTeamsProps = {
  selectedTeams: string[];
  allGames: Game[];
  selectedCompetitions?: string[];
  isOnlyUpcoming?: boolean;
};

const useGamesFromSelectedTeams = ({
  selectedTeams,
  allGames,
  selectedCompetitions = [],
  isOnlyUpcoming,
}: UseGamesFromSelectedTeamsProps): Game[] => {
  const uniqueGames = new Set<Game>();
  const selectedTeamsSet = new Set(selectedTeams);

  for (let i = 0; i < allGames.length; i++) {
    const game = allGames[i];
    if (
      selectedTeamsSet.has(game.team_home) ||
      selectedTeamsSet.has(game.team_away)
    ) {
      uniqueGames.add(game);
    }
  }

  if (selectedCompetitions.length > 0) {
    for (let i = 0; i < allGames.length; i++) {
      const game = allGames[i];
      if (selectedCompetitions.includes(game.tournament_name)) {
        uniqueGames.add(game);
      }
    }
  }

  // isOnlyUpcoming
  let gamesArray = Array.from(uniqueGames);
  if (isOnlyUpcoming) {
    gamesArray = gamesArray.filter((game) =>
      dayjs(game.starts_at).isAfter(dayjs())
    );
  }
  return gamesArray;
};

export default useGamesFromSelectedTeams;
